import Button from '@components/Button';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { DiscountCouponRow } from '@models/discount';
import { useFlow } from '@router/stackflow';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';

import DiscountItemRow from './DiscountItemRow';

interface Params {
    coupon: string;
}

const DiscountCouponBottomSheet: ActivityComponentType<Params> = ({ params }: {params: Params}) => {
    const coupon: DiscountCouponRow = JSON.parse(params.coupon);
    const { orderLines } = useCalculatedRequest();
    // 단일 상품별로 쿠폰을 적용할 수 있게 표시
    const lines = orderLines
        .filter((line) => line.couponUsable)
        .map((line) => {
            const { quantity } = line;
            return Array.from({ length: quantity }).map((_, idx) => ({
                ...line, idx,
            }));
        }).flat();
    const { pop } = useFlow();
    return (
        <BottomSheet onOutsideClick={(e) => {
            e.preventDefault();
        }}>
            <BottomSheetContainer fullWidth>
                <Contents fullWidth spacing={8}>
                    {lines.map((line) => (
                        <DiscountItemRow key={`${line.shopItemId} ${line.idx}`}
                            coupon={coupon}
                            item={line}/>
                    ))}
                </Contents>
                <Button fullWidth onClick={pop}>완료</Button>
            </BottomSheetContainer>
        </BottomSheet>
    );
};

const Contents = styled(Column)`
    max-height: 80vh;
    overflow-y: auto;
    padding-bottom: 8px;
`;

const BottomSheetContainer = styled(Column)`
    padding: 16px 16px calc(16px + var(--safe-area-bottom));
`;

export default DiscountCouponBottomSheet;
